(function ($) {

	gsap.registerPlugin(ScrollTrigger);

	ScrollTrigger.matchMedia({
		"(min-width: 1024px) and (min-height: 900px)": function () {

			let hero = $('.hero');
			let hero_tl = gsap.timeline({
				scrollTrigger: {
					trigger: hero,
					pin: true,
					scrub: true,
					snap: {
						snapTo: "labels"
					}
				}
			});

			hero.find(".hero__item").each(function (i) {
				hero_tl
					.to(
						$(this).find(".hero__img"),
						{
							opacity: 0.2,
							duration: 0.5
						},
						"-=0.5"
					)
					.to(
						$(this),
						{
							backgroundSize: "100% 4px",
							duration: 0.5
						},
						"<"
					)
					.addLabel("delay-" + i)
					.to(
						$(this),
						{
							backgroundSize: "100% 0",
							duration: 0.5
						},
						"+=1"
					)
					.to(
						$(this).find(".hero__img"),
						{
							opacity: 0,
							duration: 0.5
						},
						"<"
					);
			});

			return function () {
				hero_tl.kill();
			}

		}
	});

})(jQuery);
